import { Module } from 'vuex';
import { RootState } from '@/store';
import GroupState from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { unchoicedOperator } from '@/models/Operator';
import { GroupModel } from '@/models/Group';
import { RandomGroupingStrategy } from '@/helper/groupingStrategy';
import { BalancedOddsStrategy } from '@/helper/decideOddsStrategy';

const initialGroup: GroupModel = {
    id: 0,
    operators: [],
    drawOdds: 0,
    drawable: false,
};

const state: GroupState = {
    groups: [],
    drawedGroup: initialGroup,
    choicedOperators: [
        unchoicedOperator, unchoicedOperator, unchoicedOperator, unchoicedOperator,
        unchoicedOperator, unchoicedOperator, unchoicedOperator, unchoicedOperator,
        unchoicedOperator, unchoicedOperator, unchoicedOperator, unchoicedOperator,
    ],
    groupingStrategy: new RandomGroupingStrategy([], 0),
    decideOddsStrategy: new BalancedOddsStrategy(),
};

export const GroupStore: Module<GroupState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
